/*
 * Copyright (c) 2025, Wultra s.r.o. (www.wultra.com).
 *
 * All rights reserved. This source code can be used only for purposes specified
 * by the given license contract signed by the rightful deputy of Wultra s.r.o.
 * This source code can be used only by the owner of the license.
 *
 * Any disputes arising in respect of this agreement (license) shall be brought
 * before the Municipal Court of Prague.
 */

import "./app-title-description.css"

interface Props {
    description: string
    sourcePackageName: string
}

export const AppTitleDescription = ({ description, sourcePackageName }: Props) => (
    <div className="app-title-description">
        <div className="app-title truncate">{description}</div>
        <div className="app-description truncate">{sourcePackageName}</div>
    </div>
)
